import { useEffect } from 'react';

/**
 * React hook to notify the parent AMP iframe to resize based on the content's scrollHeight.
 * Sends a postMessage to the parent window with the new height, aiding in responsive AMP embeds.
 * The message is sent once on mount.
 */
export const useAmpEmbedResize = () => {
  useEffect(() => {
    // Send a window message to the parent, AMP in this case, to aid in resizing the package
    // within the iFrame. I used an asterisk for the target origin because we don't know
    // where the other window's document will be located. This is safe for us because
    // the only data we are sending is the scrollHeight, nothing malicious can be done with this.
    requestAnimationFrame(() => {
      window.parent.postMessage(
        {
          sentinel: 'amp',
          type: 'embed-size',
          height: document.body.scrollHeight > 100 ? `${document.body.scrollHeight}px` : '555px',
        },
        '*',
      );
    });
  });
};
